define('utils/icons',['utils/application-data'], function(applicationData) {
    var version = applicationData.version;
    var markersPrefix = '/resources/img/mapmarkers/station/';
    var markersSufix = '.png?v=' + version;

    var mkIcon = function (name) {
        return markersPrefix + name + markersSufix;
    };

    return {
        mkIcon : mkIcon,

        device: {
            POWER_10: '/resources/img/mapmarkers/power_10.png?v=' + version,
            POWER_20: '/resources/img/mapmarkers/power_20.png?v=' + version,

            STATUS_OK: '/resources/img/mapmarkers/device_status/ok.png?v=' + version,
            STATUS_NOT_SEEN: '/resources/img/mapmarkers/device_status/not_seen.png?v=' + version,
            STATUS_KO: '/resources/img/mapmarkers/device_status/ko.png?v=' + version,
            STATUS_NO: '/resources/img/mapmarkers/device_status/no.png?v=' + version,
            STATUS_WARN: '/resources/img/mapmarkers/device_status/warn.png?v=' + version,

            SIGNAL_NO: '/resources/img/mapmarkers/device_signal/no.png?v=' + version,
            SIGNAL_BAD: '/resources/img/mapmarkers/device_signal/bad.png?v=' + version,
            SIGNAL_FEW: '/resources/img/mapmarkers/device_signal/few.png?v=' + version,
            SIGNAL_MEDIUM: '/resources/img/mapmarkers/device_signal/medium.png?v=' + version,
            SIGNAL_GOOD: '/resources/img/mapmarkers/device_signal/good.png?v=' + version,
            SIGNAL_EXCELLENT: '/resources/img/mapmarkers/device_signal/excellent.png?v=' + version,

            RSSI_NO: '/resources/img/mapmarkers/device_rssi/no.png?v=' + version,
            RSSI_BAD: '/resources/img/mapmarkers/device_rssi/bad.png?v=' + version,
            RSSI_FEW: '/resources/img/mapmarkers/device_rssi/few.png?v=' + version,
            RSSI_MEDIUM: '/resources/img/mapmarkers/device_rssi/medium.png?v=' + version,
            RSSI_GOOD: '/resources/img/mapmarkers/device_rssi/good.png?v=' + version,
            RSSI_EXCELLENT: '/resources/img/mapmarkers/device_rssi/excellent.png?v=' + version
        },
        message: {
            NOT_RECEIVED: '/resources/img/mapmarkers/not_received.png?v=' + version
        }
    };
});

